(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    

if (!customElements.get('olouioo-experience-finder')) {
  customElements.define('olouioo-experience-finder', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-of-form]');
      this.steps = [...this.querySelectorAll('[data-of-step]')];
      this.index = 0;
      this.handleClick = (event) => {
        const card = event.target.closest?.('a[href="#olouioo-experience-finder"]');
        const local = event.target.closest?.('[data-of-open]');
        if ((card && this.hasAttribute('data-card-finder')) || (local && this.contains(local))) {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault(); this.opener = card || local;
          if (!this.dialog.open) this.dialog.showModal();
        }
      };
      this.handleSubmit = (event) => {
        event.preventDefault();
        if (!this.steps[this.index].querySelector('input:checked')) {
          this.querySelector('.of-error').hidden = false; return;
        }
        this.querySelector('.of-error').hidden = true;
        if (this.index < this.steps.length - 1) { this.index++; this.showStep(); }
        else this.showResults();
      };
      this.handleLocal = (event) => {
        if (event.target.closest('[data-of-close]')) this.dialog.close();
        if (event.target.closest('[data-of-back]') && this.index > 0) { this.index--; this.showStep(); }
        if (event.target.closest('[data-of-restart]')) {
          this.form.reset(); this.enquiryForm?.reset(); this.index=0; this.form.hidden=false;
          this.querySelector('[data-of-results]').hidden=true;
          this.querySelector('[data-of-enquiry-panel]').hidden=true;
          this.querySelector('.of-progress').hidden=false; this.showStep();
        }
        if (event.target.closest('[data-of-enquiry-open]')) {
          if (!this.selectedCards().length) return;
          const panel = this.querySelector('[data-of-enquiry-panel]');
          panel.hidden = false;
          panel.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          panel.querySelector('input[name="contact[name]"]')?.focus({preventScroll:true});
        }
      };
      this.handleClose = () => this.opener?.focus();
      this.enquiryForm = this.querySelector('.of-enquiry-form');
      this.handleSelection = (event) => { if (event.target.matches('[data-of-select]')) this.updateSelection(); };
      this.handleEnquirySubmit = (event) => {
        const selected = this.selectedCards();
        if (!selected.length) { event.preventDefault(); this.updateSelection(); return; }
        const answers = this.steps.map(step => {
          const choice = step.querySelector('input:checked');
          return step.querySelector('legend').textContent.trim() + ': ' + (choice?.closest('label')?.textContent.trim() || 'Not answered');
        });
        const names = selected.map(card => card.querySelector('h4').textContent.trim());
        const date = this.querySelector('[data-of-date]').value.trim();
        const venue = this.querySelector('[data-of-venue-input]').value.trim();
        const notes = this.querySelector('[data-of-notes]').value.trim();
        this.querySelector('[data-of-body]').value = [
          'Olouioo experience finder enquiry',
          'Selected experiences: ' + names.join(', '),
          ...answers,
          'Event date: ' + (date || 'To be confirmed'),
          'Venue: ' + (venue || 'To be confirmed'),
          'Additional notes: ' + (notes || 'None')
        ].join(String.fromCharCode(10));
      };
      document.addEventListener('click', this.handleClick);
      this.addEventListener('click', this.handleLocal);
      this.addEventListener('change', this.handleSelection);
      this.form.addEventListener('submit', this.handleSubmit);
      this.enquiryForm?.addEventListener('submit', this.handleEnquirySubmit);
      this.dialog.addEventListener('close', this.handleClose);
      if (this.querySelector('[data-of-enquiry-success], [data-of-enquiry-errors]')) {
        this.form.hidden = true;
        this.querySelector('.of-progress').hidden = true;
        this.querySelector('[data-of-results]').hidden = false;
        this.querySelector('[data-of-enquiry-panel]').hidden = false;
        this.dialog.showModal();
        this.querySelector('[data-of-enquiry-success], [data-of-enquiry-errors]').focus?.({preventScroll:true});
      }
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.handleClick);
      this.removeEventListener('click', this.handleLocal);
      this.form.removeEventListener('submit', this.handleSubmit);
      this.removeEventListener('change', this.handleSelection);
      this.enquiryForm?.removeEventListener('submit', this.handleEnquirySubmit);
      this.dialog.removeEventListener('close', this.handleClose);
    }
    showStep() {
      this.steps.forEach((step,i)=>step.hidden=i!==this.index);
      this.querySelector('[data-of-count]').textContent=String(this.index+1);
      this.querySelector('[data-of-back]').disabled=this.index===0;
      this.querySelector('[data-of-next]').hidden=this.index===this.steps.length-1;
      this.querySelector('[data-of-finish]').hidden=this.index!==this.steps.length-1;
      this.querySelector('.of-error').hidden=true;
      this.steps[this.index].querySelector('legend').focus();
    }
    recommendations(a) {
      const cards = [...this.querySelectorAll('[data-of-product]')];
      const available = cards.map(card => card.dataset.ofProduct);
      const custom = ['atelier','bespoke'].filter(handle => available.includes(handle));
      if (a.service === 'custom' || a.guests === 'more' || a.style === 'bespoke') return custom;
      const self = cards.filter(card => card.dataset.ofKind === 'self').map(card => card.dataset.ofProduct);
      const hosted = cards.filter(card => card.dataset.ofKind === 'hosted').map(card => card.dataset.ofProduct);
      let candidates = (a.service === 'self' ? self : a.service === 'hosted' ? hosted : [...self,...hosted]).filter(handle => available.includes(handle));
      if (a.occasion === 'corporate' && a.service === 'unsure' && custom.length) return custom;
      const score = handle => (a.style === 'table' && handle === 'la-table' ? 8 : 0)
        + (a.style === 'spritz' && handle === 'l-or' ? 8 : 0)
        + (a.occasion === 'wedding' && handle === 'l-or' ? 3 : 0)
        + (a.occasion === 'intimate' && handle === 'la-coupe-welcome-toast-table' ? 3 : 0);
      return candidates.sort((x,y) => score(y)-score(x)).slice(0,2);
    }
    selectedCards() {
      return [...this.querySelectorAll('[data-of-product]:not([hidden])')].filter(card => card.querySelector('[data-of-select]')?.checked);
    }
    updateSelection() {
      const count = this.selectedCards().length;
      const summary = this.querySelector('[data-of-selection-summary]');
      summary.textContent = count === 1
        ? summary.dataset.one
        : summary.dataset.many.replace('[count]', String(count));
      this.querySelector('[data-of-enquiry-open]').disabled = count === 0;
    }
    showResults() {
      const a = Object.fromEntries(this.steps.map(step => [step.dataset.ofStep, step.querySelector('input:checked')?.value || 'unsure']));
      const chosen=this.recommendations(a);
      let visible=0;
      const grid = this.querySelector('.of-recommendations');
      this.querySelectorAll('[data-of-product]').forEach(card => {
        card.hidden = !chosen.includes(card.dataset.ofProduct);
        const select = card.querySelector('[data-of-select]');
        if (select) select.checked = !card.hidden;
        if (!card.hidden) visible++;
      });
      chosen.forEach(handle => {
        const card = this.querySelector('[data-of-product="' + handle + '"]');
        if (card) grid.appendChild(card);
      });
      this.querySelector('[data-of-empty]').hidden=visible>0;
      this.querySelector('[data-of-venue]').hidden=!['outdoor','mixed'].includes(a.setting);
      this.querySelector('[data-of-large]').hidden=a.guests!=='more';
      this.form.hidden=true;this.querySelector('.of-progress').hidden=true;
      this.querySelector('[data-of-results]').hidden=false;
      this.querySelector('[data-of-enquiry-panel]').hidden=true;
      this.updateSelection();
      this.querySelector('[data-of-results] h3').focus({ preventScroll: true });
      this.dialog.scrollTop = 0;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olouioo-about-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('olouioo-about-tabs')) {
  customElements.define('olouioo-about-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      const list = this.querySelector('[data-tab-buttons]');
      if (!list || this.tabs.length !== this.panels.length) return;
      list.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        this.panels[i].setAttribute('role', 'tabpanel');
        this.panels[i].setAttribute('aria-labelledby', tab.id);
        this.panels[i].tabIndex = 0;
        tab.addEventListener('click', () => this.select(i, false));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (i + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.select(next, true); }
        });
      });
      this.select(0, false);
      list.hidden = false;
    }
    select(index, focus) {
      if (this.classList.contains('oa-tabs--drinks')) {
        const chapter = this.closest('.oa-chapter--drinks');
        if (chapter) chapter.dataset.flavour = String(index + 1);
      }
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      if (focus) this.tabs[index].focus();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olouioo-event-details"] && !Shopify.designMode) return;
  try {
    
function setupEventCarousels(root=document){
  root.querySelectorAll('[data-event-carousel]').forEach(section=>{
    if(section.dataset.carouselReady)return;
    section.dataset.carouselReady='true';
    const track=section.querySelector('.oed__grid'),prev=section.querySelector('[data-carousel-prev]'),next=section.querySelector('[data-carousel-next]');
    const sync=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
    const move=direction=>{const card=track.querySelector('.oed__card');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    track.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(track);sync();
  });
}
setupEventCarousels();
document.addEventListener('shopify:section:load',event=>setupEventCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olouioo-event-enquiry"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('OlouiooEventEnquiry');
  if (!form) return;
  const params = new URLSearchParams(location.search);
  for (const key of ['drinks', 'drink']) {
    if (params.get(key)?.startsWith('All three')) params.set(key, 'All three drink types included');
  }
  const keys = ['service', 'guest_tier', 'finish', 'linen', 'drinks', 'drink', 'topping', 'garnish', 'quantity', 'date', 'time', 'venue', 'setup', 'address', 'suburb', 'postcode'];
  const selected = keys.filter(key => params.get(key)).map(key => [key, params.get(key)]);
  if (!selected.length) return;
  const service = params.get('service');
  const serviceSelect = form.querySelector('#oe-service');
  if (service) {
    const option = [...serviceSelect.options].find(item => item.textContent.trim().toLowerCase() === service.trim().toLowerCase());
    if (option) serviceSelect.value = option.value;
  }
  const guests = params.get('guest_tier');
  const count = guests?.match(/\d+/)?.[0];
  if (count) form.querySelector('#oe-guests').value = count;
  const finish = params.get('finish') || '';
  if (finish) form.querySelector('#oe-drinkware').value = /glass/i.test(finish) ? 'Glass' : /acrylic/i.test(finish) ? 'Acrylic' : '';
  const drinks = params.get('drinks') || params.get('drink');
  if (drinks) form.querySelector('#oe-drinks').value = drinks;
  if (params.get('date')) form.querySelector('#oe-date').value = params.get('date');
  if (params.get('venue')) form.querySelector('#oe-venue').value = params.get('venue');
  const time = params.get('time');
  if (time) {
    const [hour, minute] = time.split(':').map(Number);
    if (Number.isInteger(hour) && Number.isInteger(minute)) {
      const label = new Intl.DateTimeFormat('en-US',{hour:'numeric',minute:'2-digit',hour12:true,timeZone:'UTC'}).format(new Date(Date.UTC(2020,0,1,hour,minute)));
      if ([...form.querySelector('#oe-time').options].some(option => option.value === label)) form.querySelector('#oe-time').value = label;
    }
  }
  const names = {service:'Service',guest_tier:'Guest tier',finish:'Drinkware',linen:'Linen colour',drinks:'Drinks',drink:'Drink',topping:'Topping',garnish:'Garnish',quantity:'Quantity',date:'Date',time:'Start time',venue:'Venue',setup:'Setup',address:'Address',suburb:'Suburb',postcode:'Postcode'};
  const summary = form.querySelector('[data-oe-selection]');
  selected.forEach(([key, value]) => {
    const li = document.createElement('li');
    li.textContent = names[key] + ': ' + value;
    summary.querySelector('ul').append(li);
  });
  summary.hidden = false;
  form.querySelector('[data-oe-options]').value = selected.map(([key,value]) => names[key]+': '+value).join(' | ');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olouioo-quote-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const directDate = document.querySelector('.oe-direct__date-control input[type="date"]');
  if (directDate) {
    const display = directDate.nextElementSibling;
    const prompt = display.textContent.trim();
    const requestedDate = new URLSearchParams(location.search).get('date');
    if (!directDate.value && /^\d{4}-\d{2}-\d{2}$/.test(requestedDate || '')) directDate.value = requestedDate;
    const syncDirectDate = () => {
      display.textContent = directDate.value
        ? new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU', { day:'numeric', month:'short', year:'numeric', timeZone:'UTC' }).format(new Date(directDate.value + 'T00:00:00Z'))
        : prompt;
      display.classList.toggle('is-selected', Boolean(directDate.value));
    };
    directDate.addEventListener('input', syncDirectDate);
    directDate.addEventListener('change', syncDirectDate);
    document.addEventListener('DOMContentLoaded', syncDirectDate);
    window.addEventListener('pageshow', syncDirectDate);
    syncDirectDate();
  }
  const root = document.querySelector('#olouioo-quote');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  root.querySelectorAll('.oq__date-control input[type="date"]').forEach(input => {
    const display = input.nextElementSibling;
    const prompt = display.textContent.trim();
    const sync = () => {
      display.textContent = input.value
        ? new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU', {day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(input.value + 'T00:00:00Z'))
        : prompt;
      display.classList.toggle('is-selected', Boolean(input.value));
    };
    input.addEventListener('change', sync);
    input.addEventListener('input', sync);
    sync();
  });
  root.classList.add(root.querySelector('.oq__success, .oq__error') ? 'oq--planning' : 'oq--intro');
  const quickSection = $('#oq-quick-enquiry');
  try {
    const saved = JSON.parse(sessionStorage.getItem('olouioo-finder-enquiry') || 'null');
    if(saved && $('#oq-quick-body')) { $('#oq-quick-body').value = saved.body; $('#oq-quick-summary').textContent = saved.body; }
  } catch {}
  if (quickSection.querySelector('.oq__quick-success,.oq__quick-errors')) {
    quickSection.hidden = false; root.classList.add('oq--quick-enquiry');
    if(quickSection.querySelector('.oq__quick-success')) { try { sessionStorage.removeItem('olouioo-finder-enquiry'); } catch {} }
  }
  $('#oq-quick-back').addEventListener('click',() => { quickSection.hidden = true; root.classList.remove('oq--quick-enquiry'); });
  const openQuickEnquiry = card => {
    const body = `Recommended experience: ${card.title}\n${root.dataset.guideAnswers || ''}`;
    $('#oq-quick-body').value = body; $('#oq-quick-summary').textContent = body;
    if (!$('#oq-quick-guests').value) $('#oq-quick-guests').value = guideAnswers.guests === '70+' ? '' : (guideAnswers.guests || '');
    try { sessionStorage.setItem('olouioo-finder-enquiry',JSON.stringify({body})); } catch {}
    quickSection.hidden = false; root.classList.add('oq--quick-enquiry');
    quickSection.style.scrollMarginTop = `${Math.max(0,...[...document.querySelectorAll('.header-section')].map(el=>el.getBoundingClientRect().height)) + 16}px`;
    quickSection.scrollIntoView({behavior:'auto',block:'start'}); $('#oq-quick-title').focus({preventScroll:true});
  };
  const service = $('#oq-service'), variant = $('#oq-variant');
  if (!service || !variant) return;
  const money = cents => new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(cents / 100);
  const inputValue = s => $(s)?.value?.trim() || '';
  const label = select => select.options[select.selectedIndex]?.textContent?.trim() || '';
  const packageTextMatch = title => (title.match(/(?:Up to )?(\d+) guests/i) || [])[1] || 0;
  const rate = kind => kind === 'hosted' ? Number(root.dataset.hostedHour || 35000) : Number(root.dataset.selfHour || 15000);
  const formatClock = total => `${(Math.floor(total / 60) % 24) % 12 || 12}:${String(total % 60).padStart(2,'0')} ${Math.floor(total / 60) % 24 < 12 ? 'am' : 'pm'}`;
  const formatDate = value => value ? new Intl.DateTimeFormat('en-AU',{day:'numeric',month:'short',year:'numeric',timeZone:'UTC'}).format(new Date(`${value}T00:00:00Z`)) : '';
  const packageInclusion = $('.oq__included>span:last-child');
  const defaultPackageInclusion = packageInclusion?.textContent || '';
  function quoteDeliveryAmounts(subtotal, zone, bands, threshold, taxesIncluded) {
    if (!Number.isSafeInteger(subtotal) || subtotal < 0 || !bands.every(value => Number.isSafeInteger(value) && value >= 0)) return null;
    const gross = fee => taxesIncluded ? subtotal + fee : subtotal + fee + Math.round((subtotal + fee) * 0.1);
    if (['15', '30', '50'].includes(zone)) {
      const delivery = threshold > 0 && subtotal >= threshold ? 0 : bands[['15', '30', '50'].indexOf(zone)];
      return { kind: 'fixed', delivery, minimum: gross(delivery), maximum: gross(delivery) };
    }
    if (zone === '') return { kind: 'range', minimum: gross(Math.min(...bands)), maximum: gross(Math.max(...bands)), low: Math.min(...bands), high: Math.max(...bands) };
    return { kind: 'quote', minimum: gross(0) };
  }
  const update = () => {
    if (root.dataset.guideAnswers) {
      $('#oq-guide-answers').value = root.dataset.guideAnswers;
      $('#oq-guide-answers').setAttribute('value', root.dataset.guideAnswers);
    }
    const selected = service.selectedOptions[0], kind = selected?.dataset.kind || '';
    const source = root.querySelector(`[data-service-variants="${service.value}"]`);
    root.querySelectorAll('.oq__service-card input').forEach(card => { card.checked = card.value === service.value; });
    const changed = variant.dataset.service !== service.value;
    if (changed) {
      variant.replaceChildren(...(source ? [...source.options].map(option => option.cloneNode(true)) : []));
      const controls = root.querySelector(`[data-service-options="${service.value}"]`);
      $('#oq-options').replaceChildren(...(controls ? [...controls.children].map(label => label.cloneNode(true)) : []));
      variant.dataset.service = service.value;
    }
    const selectedOptions = [...root.querySelectorAll('#oq-options .oq-option')].map(select => select.value);
    const matching = [...variant.options].find(option => {
      try { return JSON.parse(option.dataset.options).every((value, index) => value === selectedOptions[index]); }
      catch { return false; }
    });
    variant.value = matching?.value || '';
    const custom = kind === 'custom';
    const briefType = custom ? service.value : '';
    $('#oq-custom-brief').hidden = !custom;
    $('#oq-standard-extras').hidden = custom;
    root.querySelectorAll('#oq-custom-brief [data-brief]').forEach(group => {
      const active = group.dataset.brief === briefType;
      group.hidden = !active;
      group.querySelectorAll('input,select,textarea').forEach(field => { field.disabled = !active; });
      const other = group.querySelector('[data-other-wrap]');
      const showOther = active && group.querySelector('select[id$="-occasion"]')?.value === 'Other';
      other.hidden = !showOther;
      other.querySelector('input').disabled = !showOther;
      other.querySelector('input').required = showOther && !panels[2].hidden;
    });
    root.querySelectorAll('#oq-standard-extras input,#oq-standard-extras select,#oq-standard-extras textarea').forEach(field => { field.disabled = custom; });
    $('#oq-custom-event-hint').hidden = !custom;
    root.querySelectorAll('[data-custom-optional]').forEach(field => { field.required = !custom && !panels[1].hidden; });
    root.querySelectorAll('[data-custom-optional-label]').forEach(badge => { badge.textContent = custom ? 'If known' : 'Required'; });
    const briefFields = custom ? [...root.querySelectorAll(`#oq-custom-brief [data-brief="${briefType}"] [data-brief-label]`)] : [];
    const briefLines = briefFields.filter(field => field.value.trim()).map(field => `${field.dataset.briefLabel}: ${field.value.trim()}`);
    const briefPreview = briefLines.filter(line => /goal|occasion|moment|budget|story/i.test(line)).slice(0,3).join(' · ') || 'Awaiting your creative brief';
    progress[2].querySelector('b').textContent = custom ? 'Your brief' : 'Optional extras';
    panels[2].querySelector('legend').lastChild.textContent = custom ? ' Your brief' : ' Optional extras';
    $('#oq-summary-extras-label').textContent = custom ? 'Creative brief' : 'Optional extras';
    $('.oq__collection-heading>p').textContent = custom ? 'Choose a tailored service, then tell us what matters most.' : 'Select a design to explore its live package options.';
    $('.oq__assurance span:first-child').textContent = custom ? '01 · Duration shaped around your brief' : '01 · 6-hour self-serve · 3-hour hosted';
    $('#oq-review-extras-row').hidden = custom;
    $('#oq-review-brief-row').hidden = !custom;
    $('#oq-review-brief').textContent = briefLines.join('\n') || '—';
    $('#oq-variant-wrap').hidden = !source || custom;
    $('#oq-custom-note').hidden = !custom;
    const image = $('#oq-package-image');
    const imageUrl = matching?.dataset.image || source?.dataset.productImage || '';
    image.hidden = !imageUrl;
    image.parentElement.hidden = !imageUrl;
    if (imageUrl && image.src !== imageUrl) image.src = imageUrl;
    image.alt = service.value ? `${label(service)} — ${matching?.textContent?.trim() || ''}` : '';
    const packagePrice = matching ? Number(matching.dataset.price || 0) : 0;
    $('#oq-package-price').textContent = matching ? money(packagePrice) : '—';
    const guestCount = custom ? 0 : Number(inputValue('#oq-extra-guests'));
    const hourCount = custom ? 0 : Number(inputValue('#oq-hours'));
    const startTime = inputValue('#oq-time');
    const startMinutes = startTime ? Number(startTime.slice(0,2)) * 60 + Number(startTime.slice(3,5)) : 0;
    const finishMinutes = startMinutes + (3 + hourCount) * 60;
    const finishText = startTime ? `${formatClock(finishMinutes)}${finishMinutes >= 1440 ? ` (${root.dataset.nextDay})` : ''}` : '';
    $('#oq-finish').textContent = startTime && !custom ? `${root.dataset.finishLabel} ${finishText}` : '';
    const extraRate = Number(root.dataset.guestPrice || 3000);
    const extras = [...root.querySelectorAll('.oq-addon:checked:not(:disabled)')].map(el => ({name: el.value, price: Number(el.dataset.price || 0)}));
    if (guestCount) extras.push({name: `${guestCount} additional guests`,price: guestCount * extraRate});
    if (hourCount) extras.push({name: `${hourCount} additional hire ${hourCount === 1 ? 'hour' : 'hours'}`,price: hourCount * rate(kind)});
    const extrasPrice = extras.reduce((sum, item) => sum + item.price, 0);
    const includedCount = Number(packageTextMatch(matching?.textContent || ''));
    const expectedCount = Number(inputValue('#oq-guests'));
    if (packageInclusion) packageInclusion.textContent = kind === 'hosted' && includedCount > 0 ? root.dataset.hostedIncluded.replace('{count}', String(includedCount * 3)) : defaultPackageInclusion;
    const overCapacity = includedCount > 0 && expectedCount > includedCount + guestCount;
    const beforeDelivery = packagePrice + extrasPrice;
    const dispatchArea = inputValue('#oq-dispatch');
    const deliveryZone = inputValue('#oq-delivery-zone');
    const deliveryEstimate = quoteDeliveryAmounts(beforeDelivery, deliveryZone, [Number(root.dataset.delivery15), Number(root.dataset.delivery30), Number(root.dataset.delivery50)], Number(root.dataset.freeThreshold), root.dataset.taxesIncluded === 'true');
    const interpolateDelivery = (text, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`{${key}}`, value), text);
    const deliveryText = custom || !deliveryEstimate ? root.dataset.deliveryQuote : deliveryEstimate.kind === 'range'
      ? interpolateDelivery(root.dataset.deliveryRange, { min:money(deliveryEstimate.low), max:money(deliveryEstimate.high) })
      : deliveryEstimate.kind === 'quote' ? root.dataset.deliveryQuote
      : interpolateDelivery(root.dataset.deliverySelected, { origin:dispatchArea, zone:label($('#oq-delivery-zone')), fee:money(deliveryEstimate.delivery) });
    const deliveredText = !deliveryEstimate ? root.dataset.deliveryQuote : deliveryEstimate.kind === 'range'
      ? interpolateDelivery(root.dataset.deliveredRange, { min:money(deliveryEstimate.minimum), max:money(deliveryEstimate.maximum) })
      : deliveryEstimate.kind === 'quote' ? interpolateDelivery(root.dataset.deliveredQuote, { subtotal:money(deliveryEstimate.minimum) })
      : interpolateDelivery(root.dataset.deliveredFixed, { total:money(deliveryEstimate.minimum) });
    $('.oq__delivery-status').textContent = `${dispatchArea} · ${deliveryText}`;
    const serviceText = service.value ? label(service) : '—';
    const selectedPackageText = source ? (matching?.textContent?.trim() || 'Option unavailable — choose another combination') : custom ? 'Custom design' : '—';
    const packageText = kind === 'hosted' && includedCount > 0 ? `${selectedPackageText} · ${root.dataset.hostedCount.replace('{count}', String(includedCount * 3))}` : selectedPackageText;
    const extrasText = custom ? briefPreview : extras.length ? extras.map(item => `${item.name} (${money(item.price)})`).join(', ') : 'None selected';
    $('#oq-summary-service').textContent = serviceText;
    $('#oq-summary-package').textContent = packageText;
    $('#oq-summary-extras').textContent = extrasText;
    $('#oq-summary-delivery').textContent = deliveryText;
    $('#oq-summary-empty').hidden = Boolean(service.value);
    $('#oq-summary-filled').hidden = !service.value;
    $('#oq-review-note').hidden = !(custom || overCapacity || (service.value && !matching));
    $('#oq-total').textContent = !service.value || custom || !source ? 'Custom quote' : !matching ? 'Choose another option' : deliveredText;
    root.classList.toggle('oq--has-experience', Boolean(service.value));
    $('#oq-next').disabled = Number(root.dataset.activeStep || 0) === 0 && !service.value && !root.dataset.continueCategory;
    $('#oq-mobile-total').textContent = service.value ? $('#oq-total').textContent : root.dataset.startEstimate;
    $('#oq-review-service').textContent = serviceText;
    $('#oq-review-package').textContent = packageText;
    $('#oq-review-event').textContent = [formatDate(inputValue('#oq-date')) || (custom ? 'Date to discuss' : ''),startTime ? formatClock(startMinutes) : '',inputValue('#oq-guests') ? `${inputValue('#oq-guests')} guests` : '',inputValue('#oq-address'),inputValue('#oq-suburb'),inputValue('#oq-postcode')].filter(Boolean).join(' · ') || '—';
    const warning = $('#oq-review-warning');
    warning.hidden = !overCapacity;
    warning.textContent = overCapacity ? `Your package covers up to ${includedCount + guestCount} guests, but your event has ${expectedCount}. Edit the package or additional guests before adding to cart.` : '';
    $('#oq-review-delivery').textContent = deliveryText;
    $('#oq-review-extras').textContent = extrasText;
    $('#oq-review-contact').textContent = [inputValue('#oq-name'),inputValue('#oq-email'),inputValue('#oq-phone')].filter(Boolean).join(' · ') || '—';
    $('#oq-review-total').textContent = $('#oq-total').textContent;
    const breakdown = $('#oq-review-breakdown');
    breakdown.replaceChildren();
    if (!custom && matching) {
      [[`Package · ${serviceText}`,money(packagePrice)],...extras.map(item => [item.name,money(item.price)])].forEach(([name,price]) => {
        const row = document.createElement('div');
        row.className = 'oq__price-row';
        const title = document.createElement('span'),amount = document.createElement('span');
        title.textContent = name; amount.textContent = price;
        row.append(title,amount); breakdown.append(row);
      });
    }
    const cartReady = Boolean(source && matching && !custom && !overCapacity && !guestCount && !hourCount && [...root.querySelectorAll('.oq-addon:checked:not(:disabled)')].every(el => el.dataset.variantId));
    $('#oq-add-cart').disabled = !cartReady || root.dataset.cartBusy === 'true';
    $('#oq-cart-unavailable').hidden = cartReady;
    $('#oq-cart-unavailable').textContent = custom
      ? 'Tailored experiences are quoted personally. Prepare your custom enquiry with all your chosen details.'
      : overCapacity ? 'Your guest count exceeds the selected package. Adjust the package or prepare a custom enquiry for the full guest count.'
      : 'This selection needs a tailored quote or an available package. Prepare a custom enquiry to include everything you selected.';
    $('#oq-service-field').value = serviceText;
    $('#oq-package-field').value = packageText;
    $('#oq-delivery-field').value = deliveryText;
    $('#oq-extras-field').value = extrasText;
    const venueText = [inputValue('#oq-address'),inputValue('#oq-suburb'),inputValue('#oq-postcode')].filter(Boolean).join(', ') || 'To discuss';
    $('#oq-body').value = [`Quote request: ${serviceText}`,`Package: ${packageText}`,`Package price: ${source ? money(packagePrice) : 'To be quoted'}`,`Guests: ${inputValue('#oq-guests')}`,`Event date and start: ${[inputValue('#oq-date') || 'To discuss',startTime ? formatClock(startMinutes) : ''].filter(Boolean).join(' ')}`,`Venue: ${venueText}`,`Delivery: ${deliveryText}`,custom ? `Creative brief:\n${briefLines.join('\n')}` : `Extras: ${extrasText}`,`Preferred dispatch area: ${dispatchArea}`,`Estimated delivered total: ${custom || !source ? 'Custom quote' : deliveredText}${overCapacity ? ' — guest count exceeds selected package and additions' : ''}`,inputValue('#oq-guide-answers') ? `Guided preferences: ${inputValue('#oq-guide-answers')}` : '',!custom && inputValue('#oq-drinks') ? `Drink preferences: ${inputValue('#oq-drinks')}` : '',inputValue('#oq-occasion') ? `Occasion: ${inputValue('#oq-occasion')}` : '',inputValue('#oq-message') ? `Message: ${inputValue('#oq-message')}` : '','Estimate subject to availability, access, final delivery and tax review.'].filter(Boolean).join('\n');
    $('#oq-enquiry-preview').textContent = $('#oq-body').value;
  };
  root.dataset.guestPrice = root.getAttribute('data-guest-price') || '3000';
  root.dataset.selfHour = root.getAttribute('data-self-hour') || '15000';
  root.dataset.hostedHour = root.getAttribute('data-hosted-hour') || '35000';
  root.dataset.freeThreshold = root.getAttribute('data-free-threshold') || '600000';
  const panels = [...root.querySelectorAll('.oq__panel')];
  const progress = [...root.querySelectorAll('.oq__progress li')];
  const actions = $('.oq__step-actions');
  const stepError = $('#oq-step-error');
  const form = $('#OlouiooQuote');
  if (form) form.noValidate = true;
  const clearFieldErrors = () => {
    root.querySelectorAll('.oq__field-error').forEach(error => error.remove());
    root.querySelectorAll('[aria-invalid]').forEach(field => {
      field.removeAttribute('aria-invalid');
      if(field.dataset.previousDescription) field.setAttribute('aria-describedby',field.dataset.previousDescription); else field.removeAttribute('aria-describedby');
      delete field.dataset.previousDescription;
    });
    stepError.hidden = true;
  };
  panels.forEach(panel => panel.querySelectorAll('[required]').forEach(field => field.dataset.quoteRequired = 'true'));
  const scrollToPlanner = () => {
    const headers = [...document.querySelectorAll('.header-section')];
    const height = Math.max(0, ...headers.map(header => header.getBoundingClientRect().height));
    $('#oq-planner').style.scrollMarginTop = `${height + 16}px`;
    $('#oq-planner').scrollIntoView({behavior:'auto',block:'start'});
  };
  let step = 0, furthestStep = 0;
  const showStep = (nextStep, shouldScroll = true) => {
    step = Math.max(0, Math.min(panels.length - 1, nextStep));
    root.dataset.activeStep = String(step);
    $('#oq-next').disabled = step === 0 && !service.value && !root.dataset.continueCategory;
    furthestStep = Math.max(furthestStep,step);
    root.classList.toggle('oq--review',step === panels.length - 1);
    panels.forEach((panel,index) => {
      panel.hidden = index !== step;
      panel.querySelectorAll('[data-quote-required]').forEach(field => { field.required = index === step && !(service.selectedOptions[0]?.dataset.kind === 'custom' && field.hasAttribute('data-custom-optional')); });
    });
    root.querySelectorAll('#oq-custom-brief [data-brief]').forEach(group => {
      const other = group.querySelector('[data-other-wrap] input');
      other.required = step === 2 && !group.hidden && !other.disabled;
    });
    clearFieldErrors();
    progress.forEach((item,index) => {
      if (index === step) item.setAttribute('aria-current','step');
      else item.removeAttribute('aria-current');
      item.toggleAttribute('data-complete',index < step);
      const stepButton = item.querySelector('button');
      stepButton.disabled = index > furthestStep;
      if (index === step) stepButton.setAttribute('aria-current','step');
      else stepButton.removeAttribute('aria-current');
    });
    $('#oq-mobile-step').textContent = `Step ${step + 1} of ${panels.length} · ${progress[step].querySelector('b').textContent.trim()}`;
    $('#oq-back').hidden = step === 0;
    $('#oq-next').hidden = step === panels.length - 1;
    actions.hidden = false;
    if (shouldScroll) {
      scrollToPlanner();
      const heading = panels[step].querySelector('legend');
      heading?.setAttribute('tabindex','-1');
      heading?.focus({preventScroll:true});
    }
  };
  const stepValid = (forCart = false) => {
    clearFieldErrors();
    for (const field of panels[step].querySelectorAll('input:not([type=hidden]),select:not([hidden]),textarea:not([hidden])')) {
      if (forCart && field.closest('.oq__consent')) continue;
      if (!field.checkValidity()) {
        const fieldLabel = field.labels?.[0]?.textContent?.trim() || '';
        const message = field.id === 'oq-date' && field.validity.rangeUnderflow ? `Please choose ${formatDate(field.min)} or a later date.` : `${fieldLabel ? `${fieldLabel}: ` : ''}${field.validationMessage}`;
        stepError.textContent = message;
        stepError.hidden = false;
        field.setAttribute('aria-invalid','true');
        const error = document.createElement('span');
        error.className = 'oq__field-error';
        error.textContent = message;
        error.id = `${field.id}-error`;
        field.dataset.previousDescription = field.getAttribute('aria-describedby') || '';
        field.setAttribute('aria-describedby', [field.dataset.previousDescription,error.id].filter(Boolean).join(' '));
        const anchor = field === service ? $('#oq-service-cards') : field.closest('.oq__consent,.oq__date-control') || field;
        anchor.insertAdjacentElement('afterend',error);
        (field === service ? root.querySelector('.oq__service-card:not([hidden]) input') : field)?.focus({preventScroll:true});
        scrollToPlanner();
        return false;
      }
    }
    if (step === 0 && service.value && service.selectedOptions[0]?.dataset.kind !== 'custom' && !variant.value) {
      stepError.textContent = root.dataset.packageError;
      stepError.hidden = false;
      $('#oq-options .oq-option:last-child')?.focus({preventScroll:true});
      scrollToPlanner();
      return false;
    }
    return true;
  };
  $('#oq-back').addEventListener('click',() => showStep(step - 1));
  $('#oq-next').addEventListener('click',() => {
    if (step === 0 && !service.value && root.dataset.continueCategory) {
      const heading = $('#oq-collection-title');
      $('.oq__collection-heading').scrollIntoView({behavior:'auto',block:'start'});
      heading.setAttribute('tabindex','-1');
      heading.focus({preventScroll:true});
      return;
    }
    if (stepValid()) { showStep(step + 1); if(step === panels.length - 1 && root.dataset.preferredAction === 'enquiry') prepareEnquiry(); }
  });
  progress.forEach(item => item.querySelector('button').addEventListener('click',event => {
    const target = Number(event.currentTarget.dataset.step);
    if (target <= furthestStep && (target < step || stepValid())) showStep(target);
  }));
  root.querySelectorAll('[data-edit-step]').forEach(button => button.addEventListener('click',() => showStep(Number(button.dataset.editStep))));
  const validateAllSteps = (forCart = false) => {
    const previous = step;
    for (let index = 0; index < panels.length; index++) {
      showStep(index, false);
      if (!stepValid(forCart)) return false;
    }
    showStep(previous, false);
    return true;
  };
  const prepareEnquiry = () => {
    update();
    $('#oq-enquiry-ready').hidden = false;
    $('#oq-enquiry-consent').disabled = false;
    $('#oq-enquiry-consent').required = true;
    $('#oq-send-enquiry').disabled = false;
    $('#oq-prepare-enquiry').setAttribute('aria-expanded','true');
    $('#oq-enquiry-heading').scrollIntoView({behavior:'auto',block:'center'});
    $('#oq-enquiry-heading').focus({preventScroll:true});
  };
  $('#oq-prepare-enquiry').addEventListener('click',prepareEnquiry);
  $('#oq-add-cart').addEventListener('click',async () => {
    update();
    if ($('#oq-add-cart').disabled || !validateAllSteps(true)) return;
    const button = $('#oq-add-cart'), status = $('#oq-cart-status');
    const properties = {'Event date':inputValue('#oq-date'),'Start time':label($('#oq-time')),'Expected guests':inputValue('#oq-guests'),'Venue':[inputValue('#oq-address'),inputValue('#oq-suburb'),inputValue('#oq-postcode')].filter(Boolean).join(', '),'Contact name':inputValue('#oq-name'),'Contact email':inputValue('#oq-email'),'Contact phone':inputValue('#oq-phone'),'Occasion':inputValue('#oq-occasion'),'Event notes':inputValue('#oq-message'),'Drink preferences':inputValue('#oq-drinks'),'Guided preferences':root.dataset.guideAnswers || '', 'Delivery':$('#oq-delivery-field').value,'Preferred dispatch area':inputValue('#oq-dispatch')};
    if (service.selectedOptions[0]?.dataset.kind === 'hosted') properties['Included drinks'] = root.dataset.hostedInclusion;
    const items = [{id:Number(variant.value),quantity:1,properties},...[...root.querySelectorAll('.oq-addon:checked:not(:disabled)')].map(el => ({id:Number(el.dataset.variantId),quantity:1,properties:{...properties,'For package':label(service)}}))];
    root.dataset.cartBusy = 'true'; button.disabled = true; button.textContent = 'Adding…'; status.hidden = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if (!response.ok) { const error = await response.json(); throw new Error(error.description || error.message || 'Unable to add this selection.'); }
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch(error) {
      status.textContent = `${error.message} Please try again or send a quote request.`; status.hidden = false;
      delete root.dataset.cartBusy; update(); button.innerHTML = 'Book now <span aria-hidden="true">→</span>';
    }
  });
  $('#OlouiooQuote')?.addEventListener('submit', () => {
    update();
    if (root.dataset.guideAnswers) $('#oq-guide-answers').value = root.dataset.guideAnswers;
  });
  $('#oq-start').addEventListener('click',() => {
    root.classList.replace('oq--intro','oq--planning');
    scrollToPlanner();
    $('#oq-planner-title').focus({preventScroll:true});
  });
  $('#oq-intro-back').addEventListener('click',() => {
    root.classList.replace('oq--planning','oq--intro');
    window.scrollTo({top:0,behavior:'auto'});
    $('#oq-start').focus({preventScroll:true});
  });
  const guideQuestions = [
    {key:'guests',title:'How many guests are you expecting?',hint:'Choose a starting point. You can enter the exact number later.',choices:[['35','Up to 35 guests'],['50','Up to 50 guests'],['70','Up to 70 guests'],['70+','More than 70 guests']]},
    {key:'event',title:'What are you celebrating?',hint:'We’ll use the occasion to suggest a fitting format.',choices:[['Wedding','Wedding'],['Engagement','Engagement'],['Private party','Private party'],['Baby shower','Baby shower'],['Corporate or brand event','Corporate or brand event'],['Other occasion','Another occasion']]},
    {key:'service',title:'How would you like guests to be served?',hint:'Choose the feel of the experience, even if you are still deciding.',choices:[['self','A styled self-serve setup'],['hosted','Served by the Olouioo team'],['custom','Something made for us'],['unsure','Help me decide']]},
    {key:'moment',title:'Where should the drinks make an impact?',hint:'Think about the moment you want your guests to remember.',choices:[['welcome','At the welcome or first toast'],['gathering','A centrepiece to gather around'],['throughout','Throughout the event'],['brand','A branded or original concept']]},
    {key:'drink',title:'What drinks feel right?',hint:'This guides the recommendation. You can choose the exact menu later.',choices:[['Sparkling and spritz','Sparkling and spritz'],['Fruity and floral','Fruity and floral'],['Botanical and layered','Botanical and layered'],['Help us curate','Help us curate']]}
  ];
  const guideAnswers = {};
  let guideIndex = 0;
  const guideCards = () => [...root.querySelectorAll('.oq__service-card')].map(card => ({
    value:card.querySelector('input[type=radio]')?.value,
    kind:card.dataset.kind,
    url:card.dataset.productUrl || '',
    title:card.querySelector('.oq__card-copy strong')?.textContent?.trim() || '',
    description:card.querySelector('.oq__card-desc')?.textContent?.trim() || '',
    price:card.querySelector('.oq__card-foot>span')?.textContent?.trim() || '',
    image:card.querySelector('.oq__card-media img')?.currentSrc || card.querySelector('.oq__card-media img')?.src || ''
  })).filter(card => card.value);
  const showGuideQuestion = () => {
    const question = guideQuestions[guideIndex];
    $('#oq-guide-stage').hidden = false;
    $('#oq-guide-results').hidden = true;
    $('#oq-guide-count').textContent = `Question ${guideIndex + 1} of ${guideQuestions.length}`;
    $('#oq-guide-meter').style.width = `${(guideIndex + 1) / guideQuestions.length * 100}%`;
    $('#oq-guide-question').textContent = question.title;
    $('#oq-guide-hint').textContent = question.hint;
    $('#oq-guide-back').hidden = guideIndex === 0;
    $('#oq-guide-next').disabled = !guideAnswers[question.key];
    $('#oq-guide-selection-hint').textContent = guideAnswers[question.key] ? 'Your answer is selected. Tap Continue.' : 'Choose an answer, then tap Continue.';
    $('#oq-guide-next').textContent = guideIndex === guideQuestions.length - 1 ? 'Show my experience →' : 'Continue →';
    const choices = $('#oq-guide-options');
    choices.replaceChildren();
    question.choices.forEach(([value,title]) => {
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = title;
      button.setAttribute('aria-pressed',String(guideAnswers[question.key] === value));
      button.addEventListener('click',() => {
        guideAnswers[question.key] = value;
        choices.querySelectorAll('button').forEach(choice => choice.setAttribute('aria-pressed',String(choice === button)));
        $('#oq-guide-next').disabled = false;
        $('#oq-guide-selection-hint').textContent = guideIndex === guideQuestions.length - 1 ? 'Your answer is selected. See your recommendation below.' : 'Your answer is selected. Tap Continue.';
      });
      choices.append(button);
    });
    $('#oq-guide-question').focus({preventScroll:true});
    if (window.matchMedia('(max-width:767px)').matches) { $('#oq-guide').style.scrollMarginTop = `${Math.max(0,...[...document.querySelectorAll('.header-section')].map(el=>el.getBoundingClientRect().height)) + 12}px`; $('#oq-guide').scrollIntoView({behavior:'auto',block:'start'}); }
  };
  const guideChoiceButton = (card, primary = false, enquiry = false) => {
    const button = document.createElement('button');
    button.type = 'button';
    if (primary) { button.textContent = enquiry || card.kind === 'custom' ? 'Custom enquiry' : 'Book now'; if(enquiry) button.classList.add('oq__guide-enquiry'); }
    else {
      button.className = 'oq__guide-alternative';
      const title = document.createElement('strong'), detail = document.createElement('small'), price = document.createElement('span');
      title.textContent = card.title; detail.textContent = card.kind === 'self' ? 'Self-serve' : card.kind === 'hosted' ? 'Hosted' : 'Tailored'; price.textContent = card.price;
      button.append(title,detail,price);
    }
    button.addEventListener('click',() => {
      if (enquiry || card.kind === 'custom') { openQuickEnquiry(card); return; }
      if (card.url) { window.location.assign(card.url); return; }
      root.dataset.preferredAction = enquiry || card.kind === 'custom' ? 'enquiry' : 'book';
      $('.oq__filters').hidden = false;
      const kindButton = root.querySelector(`.oq__filter[data-filter="${card.kind}"]`);
      kindButton?.click();
      service.value = card.value;
      service.dispatchEvent(new Event('change',{bubbles:true}));
      if (guideAnswers.guests !== '70+') $('#oq-guests').value = guideAnswers.guests;
      $('#oq-occasion').value = guideAnswers.event;
      $('#oq-drinks').value = guideAnswers.drink === 'Help us curate' ? '' : guideAnswers.drink;
      $('#oq-guide-answers').value = root.dataset.guideAnswers;
      $('#oq-guide-answers').setAttribute('value', root.dataset.guideAnswers);
      update();
      const target = card.kind === 'custom' ? $('#oq-custom-note') : $('#oq-variant-wrap');
      (target?.hidden ? $('#oq-service-cards') : target)?.scrollIntoView({behavior:'smooth',block:'center'});
      (card.kind === 'custom' ? $('#oq-next') : $('#oq-options .oq-option'))?.focus({preventScroll:true});
    });
    return button;
  };
  const showGuideResults = () => {
    const cards = guideCards();
    const find = (kind, title) => cards.find(card => card.kind === kind && title.test(card.title));
    let recommended;
    const a = guideAnswers;
    if (a.guests === '70+' || a.service === 'custom' || a.moment === 'brand') recommended = (a.event === 'Corporate or brand event' ? find('custom',/Atelier/i) : find('custom',/Bespoke/i)) || cards.find(card => card.kind === 'custom');
    else if (a.service === 'hosted' || (a.service === 'unsure' && a.moment === 'throughout')) recommended = (a.drink === 'Botanical and layered' ? find('hosted',/Noir/i) : null) || find('hosted',/L’Or|L'Or/i) || cards.find(card => card.kind === 'hosted');
    else if (a.event === 'Corporate or brand event' && a.service === 'unsure') recommended = find('custom',/Atelier/i) || cards.find(card => card.kind === 'custom');
    else recommended = find('self',/La Coupe/i) || cards.find(card => card.kind === 'self');
    recommended ||= cards[0];
    if (!recommended) return;
    const serviceLabels = {self:'Styled self-serve',hosted:'Served by Olouioo',custom:'Made for us',unsure:'Help us decide'};
    const momentLabels = {welcome:'Welcome or first toast',gathering:'Centrepiece',throughout:'Throughout the event',brand:'Original concept'};
    root.dataset.guideAnswers = `Guests: ${a.guests}; Occasion: ${a.event}; Service: ${serviceLabels[a.service]}; Moment: ${momentLabels[a.moment]}; Drinks: ${a.drink}`;
    $('#oq-guide-stage').hidden = true;
    $('#oq-guide-results').hidden = false;
    $('#oq-guide-result-title').textContent = `${recommended.title} could be your starting point`;
    const reasons = [a.guests === '70+' ? 'A larger guest list may need a tailored plan.' : `${a.guests} guests gives us a starting size.`,a.service === 'hosted' ? 'You prefer service from our team.' : a.service === 'self' ? 'You prefer a styled self-serve moment.' : a.service === 'custom' ? 'You want something made around your vision.' : 'You asked us to help choose the format.',a.moment === 'welcome' ? 'The welcome moment matters most.' : a.moment === 'brand' ? 'A distinctive concept is central to your event.' : 'The guest experience shapes the setup.'];
    $('#oq-guide-reason').textContent = `${reasons.join(' ')} Explore the options and confirm the guest capacity before booking.`;
    const featured = $('#oq-guide-recommended');
    featured.replaceChildren();
    const article = document.createElement('article'); article.className = 'oq__guide-result-card';
    if (recommended.image) { const image = document.createElement('img'); image.src = recommended.image; image.alt = recommended.title; image.loading = 'lazy'; article.append(image); }
    const copy = document.createElement('div'); copy.className = 'oq__guide-result-copy';
    const kind = document.createElement('small'), title = document.createElement('strong'), desc = document.createElement('span'), price = document.createElement('span');
    kind.textContent = recommended.kind === 'custom' ? 'Tailored enquiry' : `${recommended.kind === 'hosted' ? 'Hosted' : 'Self-serve'} experience`;
    title.textContent = recommended.title; desc.textContent = recommended.description; price.textContent = recommended.price;
    const resultActions = document.createElement('div'); resultActions.className = 'oq__guide-result-actions';
    if(recommended.kind !== 'custom') resultActions.append(guideChoiceButton(recommended,true));
    resultActions.append(guideChoiceButton(recommended,true,true));
    const nextHint = document.createElement('p'); nextHint.className = 'oq__guide-action-hint';
    nextHint.textContent = recommended.kind === 'custom' ? 'Your answers go straight into your enquiry.' : 'Book on the product page, or send us your answers for a custom enquiry.';
    copy.append(kind,title,desc,price,resultActions,nextHint); article.append(copy); featured.append(article);
    const alternatives = $('#oq-guide-alternatives'); alternatives.replaceChildren();
    cards.filter(card => card.value !== recommended.value).forEach(card => alternatives.append(guideChoiceButton(card)));
    $('#oq-guide-result-title').focus({preventScroll:true});
    if (window.matchMedia('(max-width:767px)').matches) $('#oq-guide').scrollIntoView({behavior:'auto',block:'start'});
  };
  $('#oq-guide-launch').addEventListener('click',() => {
    delete root.dataset.continueCategory;
    root.querySelectorAll('.oq__filter').forEach(filter => filter.setAttribute('aria-pressed',String(filter.id === 'oq-guide-launch')));
    $('#oq-guide-launch').setAttribute('aria-expanded','true');
    $('#oq-guide').hidden = false;
    $('.oq__filters').hidden = true;
    $('.oq__collection-heading').hidden = true; $('#oq-service-cards').hidden = true; $('.oq__assurance').hidden = true;
    $('#oq-variant-wrap').hidden = true; $('#oq-custom-note').hidden = true; actions.hidden = true;
    service.value = ''; update();
    delete root.dataset.guideAnswers; $('#oq-guide-answers').value = ''; $('#oq-guide-answers').removeAttribute('value');
    guideIndex = 0; Object.keys(guideAnswers).forEach(key => delete guideAnswers[key]);
    showGuideQuestion();
  });
  $('#oq-guide-next').addEventListener('click',() => {
    if (!guideAnswers[guideQuestions[guideIndex].key]) return;
    if (guideIndex < guideQuestions.length - 1) { guideIndex += 1; showGuideQuestion(); }
    else showGuideResults();
  });
  $('#oq-guide-back').addEventListener('click',() => { guideIndex = Math.max(0,guideIndex - 1); showGuideQuestion(); });
  $('#oq-guide-close').addEventListener('click',() => {
    $('.oq__filters').hidden = false;
    root.querySelector('.oq__filter[data-filter="self"]')?.click();
    $('#oq-guide-launch').focus({preventScroll:true});
  });
  $('#oq-guide-restart').addEventListener('click',() => { guideIndex = 0; showGuideQuestion(); });
  root.querySelectorAll('.oq__filter[data-filter]').forEach(button => button.addEventListener('click',() => {
    root.dataset.continueCategory = button.dataset.filter;
    $('.oq__filters').hidden = false;
    root.querySelectorAll('.oq__filter').forEach(filter => filter.setAttribute('aria-pressed',String(filter === button)));
    $('#oq-guide-launch').setAttribute('aria-expanded','false');
    $('#oq-guide').hidden = true;
    $('.oq__collection-heading').hidden = false; $('#oq-service-cards').hidden = false; $('.oq__assurance').hidden = false;
    actions.hidden = false;
    root.querySelectorAll('.oq__service-card').forEach(card => { card.hidden = card.dataset.kind !== button.dataset.filter; });
    $('#oq-collection-title').textContent = button.dataset.filter === 'self' ? 'Choose a self-serve experience' : button.dataset.filter === 'hosted' ? 'Choose a hosted experience' : 'Tell us what you imagine';
    if (service.value && service.selectedOptions[0]?.dataset.kind !== button.dataset.filter) service.value = '';
    update();
    clearFieldErrors();
  }));
  $('#oq-service-cards').addEventListener('change',event => {
    if (event.target.matches('input[type=radio]')) { service.value = event.target.value; service.dispatchEvent(new Event('change',{bubbles:true})); }
  });
  $('#oq-service-cards').addEventListener('click',event => {
    const card = event.target.closest('.oq__service-card');
    if (card) { service.value = card.querySelector('input[type=radio]').value; update(); }
  });
  $('#oq-summary-toggle').addEventListener('click',event => {
    const button = event.currentTarget;
    button.setAttribute('aria-expanded',String(button.getAttribute('aria-expanded') !== 'true'));
  });
  const reflectDeliveryInput = event => {
    if (['oq-address', 'oq-suburb', 'oq-postcode', 'oq-dispatch'].includes(event.target.id)) $('#oq-delivery-zone').value = '';
    clearFieldErrors(); update();
  };
  root.addEventListener('change', reflectDeliveryInput);
  root.addEventListener('input', reflectDeliveryInput);
  form?.addEventListener('submit',event => {
    update();
    if (step !== panels.length - 1) { event.preventDefault(); if (stepValid()) showStep(step + 1); return; }
    if ($('#oq-enquiry-ready').hidden) { event.preventDefault(); prepareEnquiry(); return; }
    if (!validateAllSteps()) { event.preventDefault(); return; }
    if (service.value && service.selectedOptions[0]?.dataset.kind !== 'custom' && !variant.value) { event.preventDefault(); showStep(0); }
  });
  update();
  window.addEventListener('pageshow',() => { delete root.dataset.cartBusy; $('#oq-add-cart').innerHTML = 'Book now <span aria-hidden="true">→</span>'; update(); });
  if (panels.length === 5) { showStep(0,false); root.querySelector('.oq__filter[aria-pressed=true]')?.click(); }
  const requestedExperience = new URLSearchParams(location.search).get('experience')?.toLowerCase();
  if (requestedExperience === 'atelier' || requestedExperience === 'bespoke') {
    root.classList.replace('oq--intro','oq--planning');
    root.querySelector('.oq__filter[data-filter="custom"]')?.click();
    service.value = requestedExperience;
    update();
    scrollToPlanner();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olouioo-shop-coming-soon"] && !Shopify.designMode) return;
  try {
    
const initOlouiooShopGalleries = (root) => {
root.querySelectorAll('[data-olouioo-shop-gallery]').forEach((gallery) => {
  if (gallery.dataset.shopReady === 'true') return;
  gallery.dataset.shopReady = 'true';
  const slides = Array.from(gallery.querySelectorAll('[data-shop-slide]'));
  const counter = gallery.querySelector('[data-shop-counter]');
  let index = 0;
  const show = (next) => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, position) => {
      slide.hidden = position !== index;
    });
    counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
  };
  gallery.querySelector('[data-shop-previous]').addEventListener('click', () => show(index - 1));
  gallery.querySelector('[data-shop-next]').addEventListener('click', () => show(index + 1));
  gallery.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') show(index - 1);
    if (event.key === 'ArrowRight') show(index + 1);
  });
  let touchStart = null;
  gallery.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].screenX; }, { passive: true });
  gallery.addEventListener('touchend', (event) => {
    if (touchStart === null) return;
    const delta = event.changedTouches[0].screenX - touchStart;
    if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
    touchStart = null;
  }, { passive: true });
});
root.querySelectorAll('.olouioo-shop-soon').forEach((section) => {
  if (section.dataset.shopModalReady === 'true') return;
  section.dataset.shopModalReady = 'true';
  const dialog = section.querySelector('[data-shop-waitlist-dialog]');
  const nameInput = dialog.querySelector('input[name="contact[first_name]"]');
  let opener = null;
  section.querySelectorAll('[data-shop-waitlist-open]').forEach((button) => {
    button.addEventListener('click', () => {
      opener = button;
      dialog.showModal();
      nameInput.focus();
    });
  });
  dialog.querySelector('[data-shop-waitlist-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { if (opener) opener.focus(); });
  if (dialog.querySelector('[data-shop-form-result]')) dialog.showModal();
});
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initOlouiooShopGalleries(document), { once: true });
} else {
  initOlouiooShopGalleries(document);
}
document.addEventListener('shopify:section:load', (event) => initOlouiooShopGalleries(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
const guideParams = new URLSearchParams(window.location.search);
const guidePanel = document.querySelector('.olouioo-guide-return');
if (guidePanel && guideParams.has('olouioo_guest')) {
  const choices = ['olouioo_guest','olouioo_service','olouioo_style'].map(key => guideParams.get(key)).filter(Boolean);
  guidePanel.querySelector('[data-olouioo-guide-choices]').textContent = choices.join(' · ');
  guidePanel.hidden = false;
  const guestInput = document.querySelector('.product-information input[name="properties[Guest count]"]');
  const selectedCount = Number((guideParams.get('olouioo_guest') || '').match(/\d+/)?.[0]);
  if (guestInput && Number.isFinite(selectedCount) && selectedCount > 0) {
    const maximum = Number(guestInput.max) || selectedCount;
    const minimum = Number(guestInput.min) || 1;
    guestInput.value = String(Math.min(maximum, Math.max(minimum, selectedCount)));
    guestInput.dispatchEvent(new Event('input', { bubbles: true }));
    guestInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

  } catch(e) { console.error(e); }
})();
})();
